export class Locale {
  static #isInternalConstructing = false;
  #code;

  /**
   * @param {string} code
   */
  constructor(code) {
    if (!Locale.#isInternalConstructing) {
      throw new TypeError("PrivateConstructor is not constructable");
    }
    Locale.#isInternalConstructing = false;
    this.#code = code;
  }

  static get hu() {
    Locale.#isInternalConstructing = true;
    return Object.freeze(new Locale("hu"));
  }

  static get en() {
    Locale.#isInternalConstructing = true;
    return Object.freeze(new Locale("en"));
  }

  static get de() {
    Locale.#isInternalConstructing = true;
    return Object.freeze(new Locale("de"));
  }

  static get cs() {
    Locale.#isInternalConstructing = true;
    return Object.freeze(new Locale("cs"));
  }

  get code() {
    return this.#code;
  }

  get isMainSiteLanguage() {
    return (
      this.#code === Locale.hu.code ||
      this.#code === Locale.de.code ||
      this.#code === Locale.cs.code
    );
  }

  toString() {
    return `Locale[${this.#code}]`;
  }
}

export class LocaleConfig {
  #locale;

  /**
   * @param {string} locale
   */
  constructor(locale) {
    this.#locale = locale;
  }

  get currentLocale() {
    if (this.#locale === Locale.hu.code) {
      return Locale.hu;
    }
    if (this.#locale === Locale.en.code) {
      return Locale.en;
    }
    if (this.#locale === Locale.de.code) {
      return Locale.de;
    }
    if (this.#locale === Locale.cs.code) {
      return Locale.cs;
    }
    throw new Error(`Unknown locale: ${this.#locale}`);
  }
}
